<template>
    <div></div>
</template>

<script>
    export default {
        name: "ProductTabs",
        data() {
            return {
                tabs: {
                    desc: '',
                    chars: '',
                    delivery: '',
                    reviews: ''
                }
            }
        }
    };
</script>

<style scoped>

</style>
